import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { getUserGuardian } from 'actions/conversation';
import { clearSearchResults, searchPeople } from 'actions/search';
import { getMyMentorSections } from 'actions/user';
import { getSection } from 'actions/sections';
import User from '_class/User';
import { DataList, Spinner, Expandable } from 'UI';
import { Search } from 'UI/Inputs';
import { Checkbox, Button, Radio } from '@haldor/ui';
import Guardian from 'containers/Guardian/Guardian';

var SelectRecipientForm = /*#__PURE__*/function (_Component) {
  _inherits(SelectRecipientForm, _Component);

  var _super = _createSuper(SelectRecipientForm);

  /* Class setup */
  function SelectRecipientForm(props) {
    var _this;

    _classCallCheck(this, SelectRecipientForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSearchResults();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.currentUser);

      if (user.isMentor()) {
        _this.props.getMyMentorSections();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.memberships = _this.getConversationMembers(values);
        values.relationships = _this.getConversationRelationships(values);

        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupExpand", function (group, toggle) {
      var foundInState = _this.state.sections.findIndex(function (section) {
        return section.id == group.id;
      });

      if (foundInState < 0) {
        _this.props.getSection(group.id).then(function () {
          _this.setState({
            sections: [].concat(_toConsumableArray(_this.state.sections), [_this.props.group])
          });
        });
      }

      toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "getConversationRelationships", function (values) {
      var relationships = [];

      if (_this.state.selectedGuardians.length == 0) {
        return relationships;
      }

      _this.state.selectedGuardians.forEach(function (guardian) {
        _this.props.guardians.forEach(function (studentGuardian) {
          if (studentGuardian.guardians == null) {
            return;
          }

          var foundInGuardians = studentGuardian.guardians.find(function (gar) {
            return gar.id == guardian.id && studentGuardian.userId == guardian.studentId;
          });

          if (foundInGuardians != null) {
            var foundInRelationships = relationships.find(function (relationship) {
              return relationship.referenceType == 'STUDENT' && relationship.referenceId == studentGuardian.userId;
            });

            if (foundInRelationships == null) {
              relationships.push({
                referenceId: studentGuardian.userId,
                referenceType: 'STUDENT'
              });
            }
          }
        });
      });

      return relationships;
    });

    _defineProperty(_assertThisInitialized(_this), "getConversationMembers", function (values) {
      var members = [];

      if (_this.state.selectedGuardians.length > 0) {
        _this.state.selectedGuardians.forEach(function (guardian) {
          members.push({
            membershipID: guardian.id,
            membershipType: 'GUARDIAN',
            permission: 'W',
            user: guardian
          });
        });
      }

      if (_this.state.selectedPeople.length > 0) {
        _this.state.selectedPeople.forEach(function (student) {
          members.push({
            membershipID: student.userId,
            membershipType: 'USER',
            permission: 'W',
            user: student
          });
        });
      }

      if (values.senderId != null) {
        if (values.senderId != _this.props.currentUser.id) {
          var section = _this.props.sections.find(function (section) {
            return section.id == values.senderId;
          });

          if (section != null) {
            members.push({
              membershipID: values.senderId,
              membershipType: 'SECTION_OWNERS',
              permission: 'O',
              section: section
            });
          }
        } else {
          members.push({
            membershipID: values.senderId,
            membershipType: 'USER',
            permission: 'O',
            user: _this.props.currentUser
          });
        }
      }

      return members;
    });

    _defineProperty(_assertThisInitialized(_this), "onContactSelect", function (contact) {
      var selected = _this.state.selectedPeople.find(function (person) {
        return person.userId == contact.userId;
      });

      if (selected == null) {
        var selectedPeople = _this.state.selectedPeople;
        selectedPeople.push(contact);

        _this.setState({
          selectedPeople: selectedPeople
        });
      } else {
        _this.setState({
          selectedPeople: _toConsumableArray(_this.state.selectedPeople).filter(function (person) {
            return person.userId != contact.userId;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onContactToggle", function (contact, open) {
      var user = new User(_this.props.currentUser);

      if (open) {
        if ((user.isMentor() || user.isAdministrator()) && contact.userType.toLowerCase() == 'student') {
          contact.loadingGuardians = true;

          _this.setState({});

          _this.props.getUserGuardian(contact.userId).then(function () {
            contact.loadingGuardians = false;

            _this.setState({});
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (query) {
      _this.setState({
        searching: true,
        selectedGuardians: [],
        selectedPeople: [],
        selected: null
      });

      _this.props.searchPeople(query.query).then(function () {
        _this.setState({
          searching: false,
          hasMadeQuery: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianChange", function (checked, guardian, studentId) {
      var selectedGuardians = _this.state.selectedGuardians;
      var found = selectedGuardians.findIndex(function (selected) {
        return selected.id == guardian.id && selected.studentId == studentId;
      });

      if (found == -1) {
        selectedGuardians.push(guardian);
      } else {
        selectedGuardians.splice(found, 1);
      }

      _this.setState({
        selectedGuardians: selectedGuardians
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentGuardian", function (guardian, studentId) {
      guardian.studentId = studentId;

      var selected = _this.state.selectedGuardians.find(function (selectedGuardian) {
        return selectedGuardian.id == guardian.id && selectedGuardian.studentId == studentId;
      });

      selected = selected != null;

      if (guardian.active == 0) {
        return false;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: guardian.id + '-' + studentId,
        style: {
          marginBottom: '0.35rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: guardian.firstName + ' ' + (guardian.lastName != null ? guardian.lastName : ''),
        value: selected,
        onChange: function onChange(c) {
          return _this.onGuardianChange(c, guardian, studentId);
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderContact", function (contact) {
      var selected = _this.state.selectedPeople.find(function (student) {
        return student.userId == contact.userId;
      });

      var userGuardians = null;
      selected = selected != null;

      if (_this.props.guardians != null) {
        userGuardians = _this.props.guardians.find(function (userGuardian) {
          return userGuardian.userId == contact.userId;
        });
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        key: contact.userId,
        title: /*#__PURE__*/React.createElement("div", null, contact.firstName + ' ' + contact.lastName, /*#__PURE__*/React.createElement("span", {
          className: "participant-type color--meta size-14",
          onClick: function onClick() {
            return _this.onContactSelect(contact);
          }
        }, _this.props.translate(contact.userType.toLowerCase()))),
        onChange: function onChange(open) {
          return _this.onContactToggle(contact, open);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "participant"
      }, /*#__PURE__*/React.createElement("div", {
        className: "name"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: selected,
        onChange: function onChange(e) {
          return _this.onContactSelect(contact);
        },
        label: contact.firstName + ' ' + contact.lastName
      })), contact.userType.toLowerCase() == 'student' ? /*#__PURE__*/React.createElement("div", null, contact.loadingGuardians == true ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : userGuardians != null && userGuardians.guardians != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "subtitle"
      }, _this.props.translate('Guardian')), userGuardians.guardians.map(function (guardian) {
        return _this.renderStudentGuardian(guardian, contact.userId);
      })) : null) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNoResults", function () {
      if (_this.state.hasMadeQuery) {
        var noSearchHits = false;

        if (_this.props.people == null) {
          noSearchHits = true;
        } else if (_this.props.people != null && _this.props.people.length == 0) {
          noSearchHits = true;
        }

        if (noSearchHits) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '2rem'
            }
          }, _this.props.translate('no-results'));
        }
      }
    });

    _this.state = {
      group: null,
      searching: false,
      hasMadeQuery: false,
      loadingGuardians: false,
      selectedGuardians: [],
      selectedPeople: [],
      sections: []
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(SelectRecipientForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);
      var disableSubmit = false;
      var senderId = this.props.currentUser.userId;
      var userSections = this.props.sections;

      if (this.state.selectedGuardians.length == 0 && this.state.selectedPeople.length == 0) {
        disableSubmit = true;
      }

      if (userSections != null && userSections.length > 0) {
        userSections = userSections.filter(function (ss) {
          return !ss.archived;
        });
        if (userSections != null && userSections.length > 0) senderId = userSections[0].id;
      }

      var result = this.props.people;

      if (result != null) {
        result = result.filter(function (person) {
          return person.userType.toLowerCase() == 'teacher' || person.userType.toLowerCase() == 'student' || person.userType.toLowerCase() == 'staff';
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "conversation participant-picker form-container"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '.95rem'
        }
      }, /*#__PURE__*/React.createElement(Search, {
        loading: this.state.searching,
        onSubmit: this.onSearch,
        placeholder: this.props.translate('Search student or staff'),
        lengthLimit: 3
      })), /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        initialValues: {
          'senderId': senderId
        },
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, result != null && result.length != 0 ? /*#__PURE__*/React.createElement("div", {
            className: "users-list"
          }, /*#__PURE__*/React.createElement(DataList, {
            data: result,
            renderRow: _this2.renderContact
          })) : _this2.renderNoResults(), user.isMentor() && !disableSubmit ? /*#__PURE__*/React.createElement("div", {
            className: "form-row sender"
          }, /*#__PURE__*/React.createElement("label", {
            style: {
              marginTop: 0
            }
          }, _this2.props.translate('Sender')), userSections != null ? userSections.map(function (section) {
            var groupData = null;

            if (_this2.state.sections.length > 0) {
              groupData = _this2.state.sections.find(function (s) {
                return s.id == section.id;
              });
            }

            return /*#__PURE__*/React.createElement("div", {
              key: section.id,
              className: "radio-container"
            }, /*#__PURE__*/React.createElement(Field, {
              component: Radio,
              name: "senderId",
              optionValue: section.id,
              label: section.title
            }), /*#__PURE__*/React.createElement(Expandable, {
              title: null,
              onPress: function onPress(toggle) {
                return false;
              },
              onPlus: function onPlus(toggle) {
                return _this2.onGroupExpand(section, toggle);
              }
            }, /*#__PURE__*/React.createElement("strong", null, _this2.props.translate('Owners')), groupData != null ? /*#__PURE__*/React.createElement("ul", null, groupData.owners.map(function (owner) {
              return /*#__PURE__*/React.createElement("li", {
                key: owner.id
              }, owner.firstName, " ", owner.lastName);
            })) : /*#__PURE__*/React.createElement(Spinner, {
              small: true,
              center: true
            })));
          }) : null, /*#__PURE__*/React.createElement("div", {
            className: "radio-container"
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            name: "senderId",
            label: _this2.props.currentUser.firstName + ' ' + _this2.props.currentUser.lastName,
            optionValue: _this2.props.currentUser.userId
          }))) : null, /*#__PURE__*/React.createElement("div", {
            style: {
              padding: '0 1rem',
              marginTop: '1.55rem'
            }
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: disableSubmit
          }, _this2.props.translate('write-message'))));
        }
      }));
    }
  }]);

  return SelectRecipientForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    contacts: state.Conversation.contacts,
    group: state.sections.activeSection,
    people: state.Search.people,
    guardians: state.Conversation.guardians,
    sections: state.user.sections
  };
}

export default connect(mapStateToProps, {
  searchPeople: searchPeople,
  getUserGuardian: getUserGuardian,
  clearSearchResults: clearSearchResults,
  getMyMentorSections: getMyMentorSections,
  getSection: getSection
})(SelectRecipientForm);